export const REGEX = {
  IS_NON_WHITE_SPACE: /^\S*$/,
  ALPHANUMERIC: /^[a-zA-Z0-9-]{3,64}$/,
  EMAILREGEX: /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,}$/i,
  IS_CONTAINS_UPPERCASE: /^(?=.*[A-Z]).*$/,
  IS_CONTAINS_LOWERCASE: /^(?=.*[a-z]).*$/,
  IS_CONTAINS_NUMBER: /^(?=.*[0-9]).*$/,
  IS_CONTAINS_SYMBOL: /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/,
  IS_VALID_LENGTH: /^.{6,16}$/,
  IS_VALID_INPUT_LENGTH: /^.{3,64}$/,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
};
